//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../library/umum'
import FETCHING from  '../../library/fetching'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid';

export default {
  props: ["desaDataPegawaiId"],
  data() {
    return {

        form : {
            id : '',
            desa_dataPegawai_id : this.desaDataPegawaiId,
            masterPendidikan : '',
            masterPendidikanUraian : '',
            nm_sekolah : '',
            jurusan : '',
            thn_masuk : '',
            thn_lulus : '',
            tpt_pendidikan : '',
            lokasi : '',
            no : '',
            createdAt : '',
            createdBy : '',
            file : null,
        },

        fileOld : '',




        list_data : [],
        list_pendidikan : [],
        page_limit : 8,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,


        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_lihat: false,
        mdl_lihat_file: false,
        btn_add: false,

        UMUM : UMUM,
        FETCHING : FETCHING,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_srv_desa_riwayatPendidikanFormal + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              desaDataPegawaiId : this.desaDataPegawaiId,
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },


    addData : function(number) {


        var formData = new FormData();


        formData.append("id", uniqid());
        formData.append("desa_dataPegawai_id", this.form.desa_dataPegawai_id);
        formData.append("masterPendidikan", this.form.masterPendidikan);
        formData.append("nm_sekolah", this.form.nm_sekolah);
        formData.append("jurusan", this.form.jurusan);
        formData.append("thn_masuk", this.form.thn_masuk);
        formData.append("thn_lulus", this.form.thn_lulus);
        formData.append("tpt_pendidikan", this.form.tpt_pendidikan);
        formData.append("lokasi", this.form.lokasi);
        formData.append("no", this.form.no);
        formData.append("createdAt", UMUM.NOW());
        formData.append("file", this.form.file);


        
        fetch(this.$store.state.url.URL_srv_desa_riwayatPendidikanFormal + "addData", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

        // console.log(document.getElementById("editor").value)
    },


    editData : function(){

      var formData = new FormData();

        formData.append("id", this.form.id);
        formData.append("desa_dataPegawai_id", this.form.desa_dataPegawai_id);
        formData.append("masterPendidikan", this.form.masterPendidikan);
        formData.append("nm_sekolah", this.form.nm_sekolah);
        formData.append("jurusan", this.form.jurusan);
        formData.append("thn_masuk", this.form.thn_masuk);
        formData.append("thn_lulus", this.form.thn_lulus);
        formData.append("tpt_pendidikan", this.form.tpt_pendidikan);
        formData.append("lokasi", this.form.lokasi);
        formData.append("no", this.form.no);
        formData.append("file", this.form.file);

        formData.append("fileOld", this.fileOld);


      fetch(this.$store.state.url.URL_srv_desa_riwayatPendidikanFormal + "editData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_srv_desa_riwayatPendidikanFormal + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              id : this.form.id,
              fileOld : this.fileOld,

          })
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){

        this.form.id = data.id;
        this.form.desa_dataPegawai_id= data.desa_dataPegawai_id;
        this.form.masterPendidikan= data.masterPendidikan;
        this.form.masterPendidikanuraian= data.masterPendidikanuraian;

        this.form.nm_sekolah= data.nm_sekolah;
        this.form.jurusan= data.jurusan;
        this.form.thn_masuk= data.thn_masuk;
        this.form.thn_lulus= data.thn_lulus;
        this.form.tpt_pendidikan= data.tpt_pendidikan;
        this.form.lokasi= data.lokasi;

        this.form.no= data.no;
        this.form.createdAt = data.createdAt;
        this.form.createdBy = data.createdBy;
        // this.form.file = data.file;
        this.fileOld = data.file;
        // console.log(data.file)
        

    },

    emptytData : function(data){

    },



    getList : async function(){
      this.list_pendidikan = await FETCHING.FETCH_GET(this.$store.state.url.URL_DATAMASTER_PENDIDIKAN);


      console.log(this.list_pendidikan);

    },


    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },

        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        },




    // ====================================== PAGINATE ====================================

    chageDesa(){
      this.form.des_kel = ''
      if (this.form.kecamatan == '' || this.form.kecamatan == undefined || this.form.kecamatan == null) {
        WILAYAH.postDesKelAutocomplete();
      } else {
        WILAYAH.postDesKelAutocomplete(this.form.kecamatan);
      }
    },

    filterSelect : function(profile){
      if (profile.aksesWilayah == 0) {
        WILAYAH.getListDesKelFull();
        this.form.des_kel = profile.des_kel
        this.$store.state.ID_DES_KEL = profile.des_kel
        this.disable_des = true
        this.disable_kec = true
      } else if (profile.aksesWilayah == 1) {
        this.form.kecamatan = profile.kecamatan
        WILAYAH.postDesKel(profile.kecamatan)
        this.disable_kec = true
        this.disable_des = false

      } else if (profile.aksesWilayah == 2) {
        WILAYAH.getListDesKelFull();
        this.disable_kec = false
        this.disable_des = false
      }
    },







  },

  mounted () {
        // new FroalaEditor('textarea#froala-editor')
        var profilex = JSON.parse(localStorage.profile)
        var profile = profilex.profile
        this.filterSelect(profile)


        this.getList();
        this.getView();
  },
}
